import { Component, ElementRef, Input, inject } from '@angular/core';

import { DynamicHtmlDirective } from '@frontend/vanilla/core';

@Component({
    imports: [DynamicHtmlDirective],
    selector: 'vn-inbox-cta-content',
    template: `<div [vnDynamicHtml]="content"></div>`,
})
export class InboxCtaContentComponent {
    elementRef = inject(ElementRef);

    @Input() content: any;
}
